import Service from "@/services/modules/integrations.service";

const add = async ({ commit }, _object) => {
  const response = Service.add(_object);

  response.then(function(_response) {
    commit("add", _response);
  });

  return response;
};

const all = async ({ commit }) => {
  const response = Service.get();

  response.then(function(_response) {
    commit("setList", _response);
  });

  return response;
};

export default {
  add,
  all
};
